import i18next from 'i18next';
import { locales } from 'configs/i18n';

/* ------------------------------ English ------------------------------ */
i18next.addResources(locales.EN, 'PROCEDURES', {
  TITLE: 'Required Documentation',
  SUBTITLE:
    'To start this procedure, please make sure you have the following documents scanned or in digital format:',
  MANDATORY: 'Mandatory',
  OPTIONAL: 'Optional',
  START_BUTTON: 'Start Procedure',
});

/* ------------------------------ Spanish ------------------------------ */
i18next.addResources(locales.ES, 'PROCEDURES', {
  TITLE: 'Documentación Requerida',
  SUBTITLE:
    'Para iniciar este trámite, por favor asegúrese de contar con los siguientes documentos escaneados o en formato digital:',
  MANDATORY: 'Obligatorio',
  OPTIONAL: 'Opcional',
  START_BUTTON: 'Iniciar Trámite',
});
